export const arrangerPipelineConstants = {
    maxFileSize: 20,
    acceptedFileTypes: ['pdf', 'doc', 'docx'],
};